import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../components/UI/Button";
import TableTemplate from "../components/UI/TableTemplate";
import { useUpdateFamilyStatusMutation } from "../api/familyAPI";
import { Family } from "@mekimix/shared/src/types/Family";

interface FamilyTableProps {
  families: Family[];
}

const FamilyTable: React.FC<FamilyTableProps> = ({ families }) => {
  const navigate = useNavigate();
  const sortedFamilies = [...families].sort((a, b) =>
    a.family.localeCompare(b.family)
  );
  const [updateFamilyStatus] = useUpdateFamilyStatusMutation();

  const statusOptions = [
    { value: "needs_attention", label: "תשומת לב" },
    { value: "ok", label: "תקין" },
    { value: "no_meeting_month", label: "לא נפגשו חודש" },
  ];

  const handleStatusChange = async (id: string, newStatus: string) => {
    try {
      await updateFamilyStatus({ id, status: newStatus }).unwrap();
    } catch (error) {
      console.error("שגיאה בעדכון סטטוס:", error);
    }
  };
  const openFamilyCard = (id: string) => {
    navigate(`/family-dashboard/${id}`);
  };

const openMeetingForm = (familyId: string) => {
  navigate(`/meeting-form/${familyId}`);
};

  const grayButtonClasses =
    "bg-gray-300 text-gray-700 border border-gray-400 rounded px-2 py-1 hover:bg-gray-400 transition-colors duration-200";

  if (families.length === 0) {
    return <p className="p-6 text-center text-gray-500">לא נמצאו משפחות.</p>;
  }

  return (
    <div className="p-6">
      <TableTemplate>
        <thead className="bg-gray-100 text-gray-700 font-semibold">
          <tr>
            <th className="px-6 py-3 border-b">משפחה</th>
            <th className="px-6 py-3 border-b">שם</th>
            <th className="px-6 py-3 border-b">סטטוס</th>
            <th className="px-6 py-3 border-b">פעולות</th>
          </tr>
        </thead>
        <tbody>
          {sortedFamilies.map((family) => (
            <tr key={family.id} className="hover:bg-gray-50 border-t">
              <td className="px-6 py-4 border-b">{family.family}</td>
              <td className="px-6 py-4 border-b">
                {family.name_a} ו־{family.name_b}
              </td>
              <td className="px-6 py-4 border-b">
                <select
                  value={family.status}
                  onChange={(e) =>
                    handleStatusChange(family.id!, e.target.value)
                  }
                  className="border border-gray-300 rounded px-2 py-1"
                >
                  {statusOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </td>
              <td className="px-6 py-4 border-b">
                <div className="flex gap-x-2">
                  <Button
                    size="sm"
                    className={grayButtonClasses}
                    onClick={() => openMeetingForm(family.id!)}
                  >
                    פגישה חדשה
                  </Button>
                  <Button
                    size="sm"
                    className={grayButtonClasses}
                    onClick={() => openFamilyCard(family.id!)}
                  >
                    פרטים
                  </Button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </TableTemplate>
    </div>
  );
};

export default FamilyTable;
